// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3kppR","savePackageButton":"ClientWallet_savePackageButton__1lx3M"};